export enum TV {
  CONDOMINIALE = 'CONDOMINIALE',
  PRIVATO = 'PRIVATO',
  PARABOLA_SATELLITARE = 'PARABOLA_SATELLITARE',
}
